import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import Loader from '../../../App/layout/Loader';
import { useSelector } from '../../../store/reducer';
import { useDispatch } from 'react-redux';
import CompactingDivisionAuthorize from './compactingDivAuthComp';
import CompactingDivAuthDetailsComp from './compactingDivAuthDetailsComp';
import { COMPACTING_AUTHORIZATION } from '../../../store/programs/CompactingDivisionAuthorization/compactingDivAuthorization.reducer';
import { NAVIGATE_COMPACTING_DIV_AUTHORIZATION } from '../../../store/programs/CompactingDivisionAuthorization/compactingDivAuthorization.actionsType';

const CompactingDivAuthorization = () => {
    let dispatch = useDispatch();
    let { loading, iscompactingDivAuth } = useSelector((state) => {
        return state[COMPACTING_AUTHORIZATION];
    });
    const collapseMenu = useSelector((state) => state.able.collapseMenu);
    // companyMaster and ip address API call
    useEffect(() => {
        dispatch({ type: NAVIGATE_COMPACTING_DIV_AUTHORIZATION });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [collapseMenu]);

    return (
        <Row className="d-flex flex-column">
            {loading && <Loader />}
            <Col>{iscompactingDivAuth ? <CompactingDivAuthDetailsComp /> : <CompactingDivisionAuthorize />}</Col>
        </Row>
    );
};

export default CompactingDivAuthorization;
